export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/feature-payment.0c654df0-bbc8e7.svg";